"use client";
import { useStore } from "@core/store";
import { useAuthStore } from "@core/store/storeAuth";
import { requestAlegriia } from "@utils/requests";
import { useParams, useRouter } from "next/navigation";
import { useState } from "react";

import { useShallow } from "zustand/react/shallow";

export const useRefreshToken = () => {
  const { setToken } = useAuthStore(
    useShallow((state) => ({
      setToken: state.setToken,
    })),
  );

  const { unsubscribeTopics } = useStore(
    useShallow((state) => ({
      unsubscribeTopics: state.unsubscribeTopics,
    })),
  );

  const [isLoading, setIsLoading] = useState(false);
  const { lang = "es" } = useParams();

  const router = useRouter();

  const refreshToken = async () => {
    try {
      setIsLoading(true);
      const resp = await requestAlegriia.post(
        "/refresh",
        {},
        {
          withCredentials: true,
        },
      );

      if (resp.data?.token) {
        setToken(resp.data.token);
      }
    } catch (err) {
      console.log("No se pudo refrescar la sesión:", err);
      unsubscribeTopics?.();
      setToken("");
      router.replace(`/${lang}/app`);
    } finally {
      setIsLoading(false);
    }
  };

  return { refreshToken, isLoading };
};
